'use client';

import { LogOut } from 'lucide-react';
import { FC, PropsWithChildren, ReactNode } from 'react';

import { clsx } from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { resetStore } from '@app/actions/resetStore';
import { PageWithMenu } from '@app/layouts/PageWithMenu';
import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch } from '@shared/hooks/redux';
import { VStack } from '@shared/ui/Stack';
import { authLogout } from '@widgets/Auth/api/authLogout/authLogout';

import cls from './PersonalAccountLayout.module.scss';

type PersonalAccountLayoutProps = {
  activePath: string;
  rightElement?: ReactNode;
};

export const PersonalAccountLayout: FC<PropsWithChildren<PersonalAccountLayoutProps>> = ({
  children,
  activePath,
  rightElement
}) => {
  const dispatch = useAppDispatch();

  const { push } = useRouter();

  const logout = async () => {
    await authLogout();

    dispatch(resetStore());
    push(ROUTES.MAIN);
  };

  return (
    <PageWithMenu
      classNameContainer={cls.container}
      classNameContent={cls.wrapper}
      classNameMenu={cls.menu}
      menu={
        <VStack className={cls.menuContent}>
          <Link
            className={clsx(cls.link, { [cls.active]: activePath === 'profile' })}
            href={ROUTES.PERSONAL_ACCOUNT}
          >
            Профиль
          </Link>
          <Link
            className={clsx(cls.link, { [cls.active]: activePath === 'history' })}
            href={ROUTES.ORDERS_HISTORY}
          >
            История заказов
          </Link>
          <button
            className={cls.button}
            onClick={logout}
          >
            <span>Выйти</span> <LogOut size={13} />
          </button>
        </VStack>
      }
    >
      <section>{children}</section>
      {rightElement && rightElement}
    </PageWithMenu>
  );
};
